import React from "react";

// The h1's id. Ticket 13 (RCMC-10): each page's data table is named by its heading (aria-labelledby, Util/dataTable.jsx).
// One h1 per page, so one element ever has this id
export const PAGE_HEADING_ID = "page-heading";

// v1.2's page-name look (the styled div each page drew its name with), unchanged
const NAME_STYLE = { fontSize: "1.5rem", fontWeight: "bold", paddingLeft: "3px", display: "flex", alignItems: "center" };

/**
 * The page's one top heading (v1.3 ticket 11, RCMC-08): the visible page name as an h1, with v1.2's look. Every
 * signed-in page draws its name through this, so each has exactly one h1. Dialog titles stay the dialogs' names.
 * @param {React.ReactElement} [icon]  the page's icon: decoration, hidden from screen readers
 * @param {React.ReactNode} [parent]  a link back to the parent page, shown before the name as "<parent> / <name>"
 *   (a Service Request's page); the link stays outside the heading, so the heading names this page only
 * @param {object} [style]  extra style for the name (e.g. a colour)
 * @param {React.ReactNode} children  the page name
 */
const PageHeading = ({ icon, parent, style, children }) => {
  const decoration = icon && React.cloneElement(icon, { "aria-hidden": true, focusable: "false" });
  if (!parent) {
    return <h1 id={PAGE_HEADING_ID} style={{ ...NAME_STYLE, margin: 0, ...style }}>{decoration}{children}</h1>;
  }
  // Same row as v1.2's "icon, link, ' / name'". In v1.2 " / name" was one run of text, so one flex item: keep it one
  // (a block holding the separator and an inline h1 in the row's font), or a narrow row would wrap differently.
  // Ticket 16 (RCMC-04): when the row is too narrow (320px), " / name" goes to a second line, and a name with no
  // spaces (a Request ID, "SR-1760000000-qa000001": wider than 320px at this size) breaks where it must instead of
  // running off the page. Where the row fits (desktop), nothing changes.
  return (
    <div style={{ ...NAME_STYLE, flexWrap: "wrap", ...style }}>
      {decoration}
      {parent}
      <div style={{ minWidth: 0 }}>
        <span aria-hidden="true">&nbsp;/&nbsp;</span>
        <h1 id={PAGE_HEADING_ID} style={{ display: "inline", font: "inherit", margin: 0, overflowWrap: "anywhere" }}>{children}</h1>
      </div>
    </div>
  );
};

export default PageHeading;
